import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f2ce0b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "radio-button-group ml-4" }
const _hoisted_3 = { class: "radio" }
const _hoisted_4 = ["name", "value"]
const _hoisted_5 = { class: "radio-elmt mt-2 mb-2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
], -1))
const _hoisted_7 = { class: "radio-text" }
const _hoisted_8 = { class: "ml-4" }
const _hoisted_9 = { class: "checkbox-button branch-checkbox" }
const _hoisted_10 = ["onUpdate:modelValue", "onChange"]
const _hoisted_11 = { class: "checkbox-elmt" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark-box" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
], -1))
const _hoisted_13 = { class: "checkbox-text" }
const _hoisted_14 = { class: "branch-type-name" }
const _hoisted_15 = { class: "branch-address" }

export function render(_ctx, _cache) {
  const _component_Popover = _resolveComponent("Popover")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["radiobutton-branchlist", _ctx.validForm() ? 'answered' : ''])
  }, [
    _createElementVNode("h4", null, [
      _createTextVNode(_toDisplayString(_ctx.newWording) + " ", 1),
      _createVNode(_component_Popover, { popover: _ctx.obj }, null, 8, ["popover"])
    ]),
    (_ctx.question.description)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.question.description), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.question.responses, (option) => {
        return (_openBlock(), _createElementBlock("label", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            name: _ctx.uniqueIdName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.selectedOption) = $event)),
            value: option.value
          }, null, 8, _hoisted_4), [
            [_vModelRadio, _ctx.selectedOption]
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("span", _hoisted_7, _toDisplayString(option.wording), 1)
          ])
        ]))
      }), 256))
    ]),
    (_ctx.selectedOption == _ctx.question.subQuestionTriggerValue && _ctx.question.atcsSubQuestions?.length > 1)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.question.atcsSubQuestions, (sq, i) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("label", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": $event => ((_ctx.subQuestionAnswers[i]) = $event),
                onChange: $event => (_ctx.updateSubQuestionAnswer($event, i))
              }, null, 40, _hoisted_10), [
                [_vModelCheckbox, _ctx.subQuestionAnswers[i]]
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("span", _hoisted_13, [
                  _createElementVNode("h4", _hoisted_14, _toDisplayString(sq.description) + ":", 1),
                  _createElementVNode("div", _hoisted_15, _toDisplayString(sq.wording), 1)
                ])
              ])
            ])
          ]))
        }), 256))
      : _createCommentVNode("", true)
  ], 2))
}